export default "__VITE_ASSET__CAIlitZY__"